import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs';
import { ComponentWithDestroy } from 'src/app/modules/shared';
import { BreadcrumbService } from 'src/app/services/breadcrumb.service';
import { BreadcrumbNodeVM } from './_types/BreadcrumbNodeVM';
import { BreadcrumbRootVM } from './_types/BreadcrumbRootVM';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent extends ComponentWithDestroy implements OnInit {
  nodes: BreadcrumbNodeVM[];
  root: BreadcrumbRootVM;

  constructor(private breadcrumbService: BreadcrumbService, private router: Router) {
    super();
    this.nodes = [];
  }

  ngOnInit() {
    this.breadcrumbService.nodes$.pipe(takeUntil(this.destroy$)).subscribe(nodes => (this.nodes = nodes));
    this.breadcrumbService.root$.pipe(takeUntil(this.destroy$)).subscribe(root => (this.root = root));
  }

  routeToRoot() {
    this.routeToLevel(0);
  }

  routeToLevel(level: number) {
    if (level === 0) {
      this.router.navigate([this.root ? this.root.route : '.']);
      return;
    }
    const route = this.nodes[level - 1].route;
    this.router.navigate([route]);
  }
}
